<template>
  <div class="pg-integral-log">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">積分管理</div>
      <div class="breadcrumb-item">積分日誌(新)</div>
    </div>

    <div class="card-block">
      <Form inline class="pg-form-inline">
        <FormItem>
          <Select size="small" placeholder="提貨櫃點" v-model="form.admin_id">
            <Option
              :value="item.ReceivingID"
              v-for="(item, index) in shopList"
              :key="item.ReceivingID"
              >({{ item.cainiao_match }}) {{ item.ReceivingName }}</Option
            >
          </Select>
        </FormItem>
        <FormItem>
          <!-- type 積分類型 1充值 2贈送 3消費 -->
          <Select
            size="small"
            style="width: 120px"
            placeholder="積分變動類型"
            v-model="form.type"
          >
            <Option :value="1">充值</Option>
            <Option :value="2">消費</Option>
          </Select>
        </FormItem>

        <FormItem>
          <DatePicker
            class="no-suffix"
            type="datetime"
            size="small"
            clearable
            @on-change="changeStartDate"
            placeholder="操作起始日期"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
        <FormItem>-</FormItem>
        <FormItem>
          <DatePicker
            class="no-suffix"
            type="datetime"
            size="small"
            clearable
            @on-change="changeEndDate"
            placeholder="操作結束日期"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
      </Form>

      <Form inline class="pg-form-inline form-input-wrap">
        <FormItem>
          <label class="input-label">客戶名稱</label>
          <Input
            size="small"
            v-model="form.username"
            @keyup.enter.native="handleSearch()"
          />
        </FormItem>
        <FormItem>
          <label class="input-label">手機號碼</label>
          <Input
            size="small"
            v-model="form.phone"
            @keyup.enter.native="handleSearch()"
          />
        </FormItem>
        <FormItem>
          <div class="pg-btn-wrap">
            <div class="pg-btn style1" @click="handleSearch()">搜索</div>
            <div class="pg-btn style2" @click="handleExport()">導出excel</div>
          </div>
        </FormItem>
      </Form>
    </div>

    <div class="card-block pd-bt">
      <Spin fix class="pg-sub-loading" v-if="isSubmiting">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>
      <Table
        size="small"
        no-data-text="暫無數據"
        border
        :columns="table.column"
        :data="table.data"
      >
        <template slot-scope="{ row, index }" slot="type">
          <!-- 1充值，2消费 -->
          <span v-if="row.type == 1">充值</span>
          <span v-else-if="row.type == 2">消費</span>
        </template>
      </Table>

      <div class="pg-pagger" v-if="totalCount > table.data.length">
        <Row>
          <Col span="12" class="pagger-left">
            <div class="pagger-total">總共{{ totalCount }}條記錄</div>
          </Col>
          <Col span="12" class="pagger-right">
            <!-- v-if="totalCount > curPageSize" -->
            <div>
              <div class="pagger-sizer">
                <span>每頁</span>
                <Select
                  v-model="curPageSize"
                  size="small"
                  placeholder="數量"
                  @on-change="handlePageSizeChange"
                >
                  <Option :value="10">10</Option>
                  <Option :value="20">20</Option>
                  <Option :value="30">30</Option>
                  <Option :value="40">40</Option>
                  <Option :value="50">50</Option>
                </Select>
              </div>

              <div class="pagger-elevator">
                <span>跳轉</span>
                <Input
                  size="small"
                  v-model="pageInput"
                  @on-keyup="handlePageInput"
                  @on-enter="handlePageEnter"
                />
              </div>

              <Page
                size="small"
                :current="pageIndex"
                :page-size="curPageSize"
                :total="totalCount"
                @on-change="handlePageChange"
              >
              </Page>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import Store from "../../../assets/js/store.js";
export default {
  data() {
    return {
      isSubmiting: false,
      pageIndex: 1, //页码
      curPageSize: 10, //一页数量
      totalCount: 1, //总条数
      pageInput: "", //输入的页码
      // items:Store.fetch(),
      shopList: [], //使用门店

      form: {
        type: "", //积分变动类型, 1充值 2赠送 3消费
        admin_id: "",
        user_id: "",
        phone: "",
        username: "",
        remarsk: "",
        start_time: "",
        end_time: "",
      },

      table: {
        column: [
          {
            title: "操作時間",
            key: "created_at",
            align: "center",
            sortable: true,
            width: 160,
          },
          {
            title: "客戶名稱",
            key: "username",
            align: "center",
            sortable: true,
            width: 130,
          },
          {
            title: "聯絡電話",
            key: "phone",
            align: "center",
            sortable: true,
            width: 130,
          },
          {
            title: "快遞單號",
            key: "odd_number",
            align: "center",
            sortable: true,
            width: 130,
          },
          {
            title: "門店人員",
            key: "remarsk",
            align: "center",
            sortable: true,
            width: 200,
          },
          {
            title: "操作類型",
            key: "type",
            slot: "type",
            align: "center",
            sortable: true,
            width: 100,
          },
          {
            title: "現有積分",
            key: "integral_ex",
            align: "center",
            sortable: true,
            width: 100,
          },
          {
            title: "積分數量(實際充值)",
            key: "integral",
            align: "center",
            sortable: true,
            width: 100,
          },
          {
            title: "贈送積分",
            key: "integral_tw",
            align: "center",
            sortable: true,
            width: 130,
          },
          {
            title: "積分變動",
            key: "integral_ch",
            align: "center",
            sortable: true,
            width: 100,
          },
          {
            title: "積分結餘",
            key: "integral_ba",
            align: "center",
            sortable: true,
            width: 100,
          },
          {
            title: "描述",
            key: "describe",
            align: "center",
            sortable: true,
            width: 600,
          },
        ],
        data: [],
      },
    };
  },
  mounted() {
    this.getShopList();
  },
  methods: {
    changeStartDate(e) {
      this.form.start_time = e;
    },
    changeEndDate(e) {
      this.form.end_time = e;
    },
    //获取使用门店
    getShopList() {
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: "get",
          data: {
            company_id: 0,
            type: 1,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.shopList = res.data.data.filter((it) => it.company_id != 15);
            if (res.data.data.length <= 1) {
              this.form.admin_id = res.data.data[0].ReceivingID;
            }
            this.getList();
          }
        });
    },
    getList() {
      let form = this.form;
      this.isSubmiting = true;

      this.$Rq
        .requestAuth({
          url: this.$Api.integralNewLog,
          method: "post",
          data: {
            offset: (this.pageIndex - 1) * this.curPageSize,
            limit: this.curPageSize,
            type: form.type,
            admin_id: form.admin_id,
            username: form.username,
            start_time: form.start_time,
            end_time: form.end_time,
            phone: form.phone,
            remarsk: form.remarsk,
          },
        })
        .then((res) => {
          this.isSubmiting = false;
          if (res.code == 0) {
            let tempArr = [];
            let resData = res.data.data;

            for (let i = 0; i < resData.length; i++) {
              if (resData[i].type == 1) {
                tempArr.push({
                  username: resData[i].user
                    ? resData[i].user.user_name
                    : "- - -",
                  phone: resData[i].user ? resData[i].user.phone : "- - -",
                  odd_number: resData[i].odd_number
                    ? resData[i].odd_number
                    : "- - -",
                  admin_id: resData[i].admin_id ? resData[i].admin_id : "",
                  created_at: resData[i].created_at
                    ? resData[i].created_at
                    : "",
                  describe: resData[i].describe ? resData[i].describe : "",
                  integral: resData[i].integral ? resData[i].integral : "",
                  integral_ba: resData[i].integral_ba
                    ? resData[i].integral_ba
                    : "",
                  integral_ch: resData[i].integral_ch
                    ? resData[i].integral_ch
                    : "",
                  integral_ex: resData[i].integral_ex
                    ? resData[i].integral_ex
                    : "",
                  integral_tw: resData[i].integral_tw
                    ? resData[i].integral_tw
                    : "",
                  remarsk: resData[i].remarsk ? resData[i].remarsk : "- - -",
                  type: resData[i].type ? resData[i].type : "",
                  uid: resData[i].uid ? resData[i].uid : "",
                });
              } else if (resData[i].type == 2) {
                tempArr.push({
                  username: resData[i].user
                    ? resData[i].user.user_name
                    : "- - -",
                  phone: resData[i].user ? resData[i].user.phone : "- - -",
                  odd_number: resData[i].odd_number
                    ? resData[i].odd_number
                    : "- - -",
                  admin_id: resData[i].admin_id ? resData[i].admin_id : "",
                  created_at: resData[i].created_at
                    ? resData[i].created_at
                    : "",
                  describe: resData[i].describe ? resData[i].describe : "",
                  integral: 0,
                  integral_ba: resData[i].integral_ba
                    ? resData[i].integral_ba
                    : 0,
                  integral_ch: resData[i].integral_ch
                    ? "-" + resData[i].integral_ch
                    : 0,
                  integral_ex: resData[i].integral_ex
                    ? resData[i].integral_ex
                    : 0,
                  integral_tw: 0,
                  remarsk: resData[i].remarsk ? resData[i].remarsk : "- - -",
                  type: resData[i].type ? resData[i].type : "",
                  uid: resData[i].uid ? resData[i].uid : "",
                });
              }
            }

            this.totalCount = res.data.count;
            this.table.data = tempArr;
          } else {
            this.showTipInfo(res.msg);
          }
        })
        .catch((err) => {
          this.isSubmiting = false;
        });
    },

    handleSearch() {
      this.pageIndex = 1;
      this.getList();
    },
    //pager
    handlePageSizeChange(value) {
      this.pageIndex = 1;
      this.getList();
    },
    handlePageInput() {
      let value = ("" + this.pageInput).replace(/\D/g, "");
      let pageCount = Math.ceil(this.totalCount / this.curPageSize);
      if (value > pageCount) {
        value = pageCount;
      }
      this.pageInput = value;
    },
    handlePageEnter() {
      if (this.pageInput == "" || this.pageInput == this.pageIndex) return;
      if (this.pageInput == 0) {
        this.pageInput = 1;
      }
      this.pageInput = parseInt(this.pageInput);
      this.pageIndex = this.pageInput;
      this.getList();
    },
    handlePageChange(value) {
      this.pageIndex = value;
      this.getList();
    },
    handleExport() {
      let token = localStorage.getItem("jyb_token");
      let form = this.form;
      let params = {
        Authorization: token,
        offset: (this.pageIndex - 1) * this.curPageSize,
        limit: this.curPageSize,
        type: form.type,
        start_time: this.$Utils.formatDate(form.start_time),
        end_time: this.$Utils.formatDate(form.end_time),
        admin_id: form.admin_id,
        username: form.username,
        remarsk: form.remarsk,
        phone: form.phone,
      };
      let formatParams = this.$Utils.formateObjToParamStr(params);

      if (form.start_time == "") {
        this.$Utils.showTipInfo("請選擇起始時間");
      } else if (form.end_time == "") {
        this.$Utils.showTipInfo("請選擇結束時間");
      } else {
        this.getList();
        window.open(
          `${this.$Api.integralNewLogExport}?${formatParams}`,
          "_blank"
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "IntegralNewLog.scss";
</style>
